import { queryOptions, useQuery } from '@tanstack/react-query'
import { getHeaders, handleErrors } from 'services/api/utils'
import { findOutWhichEnv, getEnvPath } from 'utils/env'

const env = findOutWhichEnv()
const BASE_PATH = `${getEnvPath(env)}/1.0/api`

function getWabaList() {
  return fetch(`${BASE_PATH}/waba`, getHeaders('GET'))
    .then((r) => r.json())
    .then(handleErrors)
}

function handleSelectData(response, withCatalog = true) {
  let data = []
  if (response.data?.length) {
    if (withCatalog) {
      return response.data
    }
    data = response.data.map((waba) => {
      const newWaba = waba
      delete newWaba.catalog
      return newWaba
    })
  }
  return data
}

export const QUERY_WABA_KEY = 'get-waba-list'

export const wabasGetQueryOptions = () => {
  return queryOptions({
    queryKey: [QUERY_WABA_KEY],
    queryFn: async () => {
      const response = await getWabaList()
      return response
    },
    select: handleSelectData,
    retry: (failureCount, error) => {
      if (error.message.includes('40')) {
        return false
      }
      return failureCount < 2
    },
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 15000),
    staleTime: 2 * (60 * 1000), // 2 mins
    cacheTime: 4 * (60 * 1000), // 4 mins
  })
}

const useGetWabaList = () => {
  return useQuery({
    queryKey: [QUERY_WABA_KEY],
    queryFn: getWabaList,
    select: handleSelectData,
    retry: 2,
    staleTime: 2 * (60 * 1000), // 2 mins
    cacheTime: 4 * (60 * 1000), // 4 mins
  })
}

export default useGetWabaList
